import Parse, { Role } from 'parse'
import moment from 'moment-timezone'

moment.locale('es')
moment.tz.setDefault('America/Mexico_City')

class User extends Parse.User {

  constructor() {
    super('_User')
  }

  static roleUser = "6fFJtMcw4U"
  static roleProfessional = "4aYcG3DVXG"

  get createdAt() {
    return moment(this.get('createdAt')).format('dddd DD MMMM, YYYY')
  }

  get isBlocked() {
    return this.get('blocked')
  }

  get status() {
    return this.get('blocked') ? 'Bloqueado' : 'Normal'
  }

  get username() {
    return this.get('username')
  }

  get name() {
    return this.get('name')
  }

  get lastname() {
    return this.get('lastname')
  }

  get fullname() {
    try {
      return `${this.get('name')} ${this.get('lastname').slice(0, 1).toUpperCase()}.`.replace(/ /g, '\u00a0')
    } catch (error) {
      return 'Usuario no encontrado'
    }
  }

  get unmaskedFullname() {
    try {
      return `${this.get('name')} ${this.get('lastname')}`.replace(/ /g, '\u00a0')
    } catch (error) {
      return 'Usuario no encontrado'
    }
  }

  get gender() {
    return this.get('gender')
  }

  get email() {
    return this.get('username')
  }

  get role() {
    return this.get('role')
  }

  get objectId() {
    return this.get('objectId')
  }

  get phone() {
    return this.get('phone')
  }

  get avatar() {
    return this.get('avatar') ? this.get('avatar').url() : null
  }

  get rating() {
    return this.get('rating')
  }

  get credits() {
    return this.get('credits')
  }

  get blocked() {
    return this.get('blocked')
  }

  get source() {
    return this.get('howFindUs') || 'Otro'
  }

  get birthday() {
    let birthday = this.get('birthday')
    return birthday ? moment(birthday).format('DD/MM/YYYY') : '-'
  }

  //--- Relations and pointers

  loadCards() {
    return this.relation('cards').query().find()
  }

  loadAppointment() {
    return this.relation('appointments').query()
      .include(['service', 'user', 'professional'])
      .find()
  }

  loadDirections() {
    return this.relation('addresses').query().find()
  }


  //-- Update

  static convertUser(user) {


    /*var role = Parse.Object.extend("_Role");
    
    var pointer = new role();
    pointer.id = this.roleProfessional;
    
    let id = user.id
    let pc = User.createWithoutData(id)

    pc.set("role", pointer)

    return pc.save()*/

    let params = {
      user_id: user.id,
      is_professional: true
    }

    return Parse.Cloud.run('adminChangeUserRole', params)

  }

  static blocked(user) {
    let id = user.id
    let pc = User.createWithoutData(id)
    pc.set("blocked", true)

    return pc.save()
  }

  static notblocked(user) {
    let id = user.id
    let pc = User.createWithoutData(id)
    pc.set("blocked", false)

    return pc.save()
  }


  //-- Stylelist

  static detailStylist(id) {
    let query = new Parse.Query(this)
    return query.get(id)
  }

  static convertStylist(user) {
    /*var role = Parse.Object.extend("_Role");
    
    var pointer = new role();
    pointer.id = this.roleUser;
    
    let id = user.id
    let pc = User.createWithoutData(id)

    pc.set("role", pointer)

    return pc.save()
*/
    let params = {
      user_id: user.id,
      is_professional: false
    }

    return Parse.Cloud.run('adminChangeUserRole', params)
  }

  loadRole(user) {
    var query = new Parse.Query('_Role');
    return query.get(user.role.id)
  }

  //--- Search

  static search(content, limit = 100, skip = 0) {
    let queryName = new Parse.Query(this).matches('name', content, 'i')
    let queryLastname = new Parse.Query(this).matches('lastname', content, 'i')
    let queryUsername = new Parse.Query(this).contains('username', content)
    let queryPhone = new Parse.Query(this).contains('phone', content)

    return Parse.Query.or(queryName, queryLastname, queryUsername, queryPhone)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      .find()
  }

  //--- Load
  static total() {
    return new Parse.Query(this).count()
  }

  //--- Count
  static count() {
    return new Parse.Query(this).count()
  }

  static loadFilter() {
    return new Parse.Query(this)
      .ascending('createdAt')
      .equalTo('role', { "__type": "Pointer", "className": "_Role", "objectId": this.roleUser })
      .find()
  }


  static load(limit, skip) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      .include(['appointment'])
      .equalTo('role', { "__type": "Pointer", "className": "_Role", "objectId": this.roleUser })
      .find()
  }

  static reload(limit = 500, skip = 0) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      .equalTo('role', { "__type": "Pointer", "className": "_Role", "objectId": this.roleUser })
      .find()
  }

  static filter(content, limit = 500, skip = 0) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .ascending(content)
      .find()
  }

  static loadStylelist(limit = 500, skip = 0) {
    let role = Role.createWithoutData(this.roleProfessional)

    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      .equalTo('role', role)
      .find()
  }

  static searchStylelist(content, limit = 500, skip = 0) {

    let queryName = new Parse.Query(this).matches('name', content, 'i')
    let queryLastname = new Parse.Query(this).matches('lastname', content, 'i')
    let queryUsername = new Parse.Query(this).contains('username', content)
    let queryPhone = new Parse.Query(this).contains('phone', content)

    return Parse.Query.or(queryName, queryLastname, queryUsername, queryPhone)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      .equalTo('role', { "__type": "Pointer", "className": "_Role", "objectId": this.roleProfessional })
      .find()
  }

  static count() {
    return new Parse.Query(this)
      .equalTo('role', { "__type": "Pointer", "className": "_Role", "objectId": this.roleUser })
      .count()
  }

  static countStylist() {
    return new Parse.Query(this)
      .equalTo('role', { "__type": "Pointer", "className": "_Role", "objectId": this.roleProfessional })
      .count()
  }

  static detail(id) {
    //console.log('detail')
    let query = new Parse.Query(this)

    return query.get(id)
  }

  static getObject(id) {
    return new Parse.Query(this).get(id)
  }


  dump() {
    console.log(this)
  }

}

export default User
